<template>
  <div v-if="can('write_customers')" class="card mb-4">
    <div class="card-body">
      <h4>{{ $t('access_tokens') }}</h4>
      <p>
        {{ $t('revoke_customer_tokens_description') }}
      </p>
    </div>
    <div class="card-footer d-flex justify-content-center">
      <button
        class="btn btn-danger"
        @click="confirmModal($event, $t('are_you_sure'), $t('revoke_customer_tokens_warning'), revokeCustomerTokens)"
      >
        {{ $t('revoke_customer_tokens') }}
      </button>
    </div>
  </div>
</template>

<script>
import Api from '@/store/jsonapi';
export default {
  name: 'WsRevokeCustomerTokens',
  props: {
    customer: Object
  },
  methods: {
    revokeCustomerTokens() {
      Api.create('revoke_user_2fa_tokens_for_customer', {
        tenant: this.customer.tenant_name,
        email: this.staff.email
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
